<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="eastel-business-nav light print:hidden"
    [appearance]="'compact'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div
            class="eastel-brand relative flex h-18 items-center justify-center border-b border-slate-200/70"
        >
            <img class="w-14" src="/images/eastel/logo.svg" alt="Eastel" />
            <div
                class="absolute bottom-2 right-4 text-center text-xs font-bold italic tracking-wide text-violet-700"
            >
                BOSS
            </div>
        </div>
    </ng-container>

    <ng-container fuseVerticalNavigationContentFooter>
        <div class="px-3 pb-4 pt-3 text-center">
            <span
                class="inline-flex rounded-md bg-slate-100 px-2 py-1 font-mono text-[10px] font-medium text-slate-500"
            >
                v{{ appVersion }}
            </span>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div
    class="eastel-business-shell flex h-dvh w-full min-w-0 flex-auto flex-col overflow-hidden"
>
    <!-- Header -->
    <div
        class="eastel-business-header sticky top-0 z-[60] flex h-18 w-full flex-none items-center border-b border-slate-200/80 bg-white/95 px-4 backdrop-blur md:px-6 print:hidden"
    >
        <button
            mat-icon-button
            class="mr-3 !rounded-xl !bg-slate-50 text-slate-600"
            matTooltip="Toggle navigation"
            (click)="toggleNavigation('mainNavigation')"
        >
            <mat-icon
                class="icon-size-5"
                [svgIcon]="'heroicons_outline:bars-3'"
            ></mat-icon>
        </button>

        <div class="min-w-0">
            <div
                class="hidden items-center gap-1 text-[11px] font-medium text-slate-400 sm:flex"
            >
                <span>Eastel BOSS</span>
                <mat-icon class="text-sm">chevron_right</mat-icon>
                <span>{{ pageSection }}</span>
            </div>
            <h1
                class="truncate text-base font-semibold tracking-tight text-slate-900 sm:text-lg leading-[1.3]"
            >
                {{ pageTitle }}
            </h1>
        </div>

        <div class="ml-auto flex items-center gap-1 pl-3 sm:gap-2">
            <!-- <notifications></notifications> -->
            <div class="mx-1 hidden h-7 w-px bg-slate-200 sm:block"></div>
            <div class="hidden min-w-0 text-right lg:block">
                <p
                    class="max-w-48 truncate text-xs font-semibold text-slate-800"
                >
                    {{ displayName }}
                </p>
                <div
                    class="flex items-center justify-end gap-1.5 text-[10px] font-medium uppercase tracking-wide text-slate-400"
                >
                    <span class="max-w-28 truncate">{{ roleLabel }}</span>
                    @if (systemUser?.branchCode) {
                        <span aria-hidden="true">&middot;</span>
                        <span class="font-mono text-slate-600">Branch {{ systemUser.branchCode }}</span>
                    }
                </div>
            </div>
            <user [showAvatar]="false"></user>
        </div>
    </div>

    <!-- Content -->
    <div
        class="eastel-route-stage relative flex min-h-0 flex-auto flex-col overflow-y-auto bg-slate-50/60"
    >
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div
        class="relative z-49 flex min-h-10 w-full flex-0 items-center justify-between border-t border-slate-200/80 bg-white px-4 text-[10px] text-slate-400 md:px-6 print:hidden"
    >
        <span>&copy; {{ currentYear }} Eastel BOSS</span>
        <div class="flex items-center gap-3">
            <span class="hidden sm:inline">Business Operations System</span>
            <span class="h-3 w-px bg-slate-200"></span>
            <span class="font-mono font-medium text-slate-500"
                >v{{ appVersion }}</span
            >
        </div>
    </div>
</div>
